import React from "react";
import Cookie from "../Cookie";
import Util from "../Util";
import Request from "../Request";
import Platform from "../Platform";
import Bridge from "../Bridge";
const {XtAxios4,setHeader,setListenKey} = Request;
import { XtContext } from "./XtContext";

export function XtAuth({ renderLogin, renderNotLogin, onAuthError, forceCheck }) {
  const [appState, appDispatch] = React.useContext(XtContext);
  const {loginStatus} = appState;
  React.useEffect(() => {
    const token = (Platform.isInApp() ? Bridge.getToken() : null) || Cookie.get("token");
    const handleErr = () => {
      if(onAuthError)
        onAuthError();
    };
    if(!token)
    {
      appDispatch({ payload: { loginStatus:2 } });
      handleErr();
      return;
    }
    setHeader({token:token,Authorization:`Bearer ` + token});
    setListenKey(token);
    if(!XtAxios4.isAuthing && (loginStatus != 1 || forceCheck))
    {
      XtAxios4.get(Util.getOrigin("www") + "/uaapi/user/user/getUserInfo", {
        noHandle401: true,
      })
      .then((userInfo) => {
        appDispatch({ payload: { userInfo,loginStatus:1 } });
        XtAxios4.get(Util.getOrigin("www") + "/uaapi/user/user/kyc/getRealAuthInfo")
        .then((data)=>{
          appDispatch({ payload: { authInfo:data } });
        })
      })
      .catch((err) => {
        // 仅当明确返回 401（token 无效）时才清除 cookie，避免因请求取消、网络错误等误删 token
        // 用户未等 getUserInfo 完成就跳转时，请求可能被取消，若此时删 token 会导致新页面登录态丢失
        const isUnauthorized = err?.response?.status === 401;
        const isTokenInvalid = err?.response?.data?.code === 401;
        if (isUnauthorized || isTokenInvalid) {
          Cookie.remove("token");
          setHeader({token:"",Authorization:""});
        }
        appDispatch({ payload: { loginStatus:2 } });
        handleErr();
      }).finally(() => {
        XtAxios4.isAuthing = false;
      });
      XtAxios4.isAuthing = true;
    }
  }, []);
  React.useEffect(()=>{
    if(location.hostname == "localhost")
      return;
    var rightHost = process.env.NEXT_PUBLIC_host || "www.spikex.com";
    var find = "."+rightHost.split(":")[0]?.split(".").slice(-2).join(".");
    var replace = "."+location.host.split(":")[0]?.split(".").slice(-2).join(".");
    if(find == replace)
      return;
    var aList = document.getElementsByTagName("a");
    for(var i=0;i<aList.length;++i)
    {
      var host = aList[i].host;
      if(host.indexOf(find) >= 0)
        aList[i].href = aList[i].href.replace(find,replace);
    }
  },[]);

  return <>{ loginStatus == 1 ? renderLogin && renderLogin(appState.userInfo) : loginStatus > 0 ? renderNotLogin && renderNotLogin() : null}</>;
}
